"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customTabsSelector = exports.selectFavoriteMatchIdsBySport = exports.selectFavoriteMarketsId = exports.selectFavoriteMarkets = void 0;
var reselect_1 = require("reselect");
var core_1 = __importDefault(require("@gin-betting/core"));
var constants_1 = require("./constants");
var selectSportIdFromProps = core_1.default.entities.selectors.selectSportIdFromProps;
var selectFavoriteMarkets = function (state) {
    return state.get(constants_1.NAME);
};
exports.selectFavoriteMarkets = selectFavoriteMarkets;
exports.selectFavoriteMarketsId = reselect_1.createSelector(exports.selectFavoriteMarkets, function (favoriteMarkets) { return favoriteMarkets.get('favoriteMarketsId'); });
exports.selectFavoriteMatchIdsBySport = reselect_1.createSelector(selectSportIdFromProps, exports.selectFavoriteMarketsId, function (sportId, favoriteMarkets) { return favoriteMarkets[sportId]; });
exports.customTabsSelector = reselect_1.createSelector(exports.selectFavoriteMatchIdsBySport, function (favoriteIds) {
    if (favoriteIds === null || favoriteIds === void 0 ? void 0 : favoriteIds.length) {
        return {
            favorite: favoriteIds,
            dynamic: constants_1.DYNAMIC_IDS,
        };
    }
    return {
        dynamic: constants_1.DYNAMIC_IDS,
    };
});
//# sourceMappingURL=selectors.js.map